//#region Import
import React, { Component } from 'react';
/* React Router */
import { withRouter } from 'react-router-dom';

/* Object Json */
import { isFunction } from 'iotera-base/object';

/* Icon */
import {
  MdWidgets as IconWidget,
  MdCropFree as IconFullScreen,
  MdPowerSettingsNew as IconLogout
}
  from 'react-icons/md';

import Person from '@material-ui/icons/Person';
import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';


/* React Strap */
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown
} from "reactstrap";

/* Screenfull */
import screenfull from "screenfull";

/* Style */
import "./style.css";
import { safeDeepGet, safeDeepGetWithType } from "iotera-base/json";
import { S, AppLink, isTenant } from "../../routes/routes";
import { Typography } from "@material-ui/core";
//#endregion

class Header extends Component {
  constructor(props) {
    super(props);
    const _isTenant = isTenant(props);
    this.state = {
      logoutSuccess: false,
      _isTenant
    };

    this.handleLogout = this.handleLogout.bind(this);
    this.handleApi = this.handleApi.bind(this);
  }

  handleLogout = e => {
    const logout = safeDeepGet(this, ['props', "logout"]);
    if (isFunction(logout)) {
      logout();
    }
  };

  handleApi = e => {
    // this.props.history.push("." + S + "_api_");
  };

  render() {
    const title = safeDeepGetWithType(this, ['props', "titleHeader"], '');
    const isTenant = safeDeepGetWithType(this, ['props', "_isTenant"], false);
    const pathApi = isTenant ? '_dashboard_list_' : '_api'
    return (
      <AppBar position="sticky">
        <Toolbar>
          <div style={{ marginRight: 36 }}>
            <Tooltip
              TransitionComponent={Zoom}
              title="Navigation Bar"
              enterDelay={500}
            >
              <IconButton color="inherit" aria-label="Menu">
                <MenuIcon
                  size="24"
                  onClick={
                    this.props.toggleNav
                  }
                />
              </IconButton>
            </Tooltip>
          </div>

          <Typography
            variant="h5"
            color="inherit"
            style={{ flexGrow: 1, textTransform: "capitalize" }}
          >
            {title}
          </Typography>
          <div>
            <Tooltip
              TransitionComponent={Zoom}
              title="Full Screen"
              enterDelay={500}
            >
              <IconButton color="inherit" aria-label="Menu">
                <IconFullScreen
                  size="24"
                  onClick={event => {
                    if (screenfull.enabled) {
                      screenfull.toggle();
                    }
                  }}
                />
              </IconButton>
            </Tooltip>
          </div>

          <div>
            <Tooltip TransitionComponent={Zoom} title="Akses" enterDelay={500}>
              <UncontrolledDropdown>
                <DropdownToggle tag="div">
                  <IconButton color="inherit" aria-label="Menu">
                    <Person size="24" />
                  </IconButton>
                </DropdownToggle>
                <DropdownMenu right style={{ minWidth: "12rem" }}>
                  {this.props.hideApi ?
                    <DropdownItem
                      onClick={this.handleLogout}
                      style={{ marginLeft: 7 }}
                    >
                      <IconLogout size="16" />
                      &emsp;Logout
                </DropdownItem>
                    :
                    <React.Fragment>
                      <AppLink {...this.props} to={pathApi}  >
                        <DropdownItem
                          style={{ marginLeft: 7 }}
                        >
                          <IconWidget size="16" />
                          &emsp;API
                    </DropdownItem>
                      </AppLink>

                      <DropdownItem onClick={this.handleLogout}>
                        <IconLogout size="16" />
                        &emsp;Logout
                    </DropdownItem>
                    </React.Fragment>
                  }

                </DropdownMenu>
              </UncontrolledDropdown>
            </Tooltip>
          </div>
        </Toolbar>
      </AppBar>
    );
  }
}

export default withRouter(Header);